<script lang="ts" setup>
import './FormKitCustomUserSwitchCompany.scss'
const companyModel = ref<boolean>(false)
</script>
<template>
  <div class="row formkit-custom-user-switch-company-wrapper">
    <div class="col-12 col-md-6">
      <FormKit
        v-model="companyModel"
        validation="required"
        type="radio"
        name="IsCompany"
        label="typ účtu"
        :options="[
          {
            label: 'Fyzická osoba',
            value: false,
          },
          {
            label: 'Spoločnosť',
            value: true,
          },
        ]"
      />
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6">
      <FormKitCustomAgreementNumber />
    </div>
    <div class="col-12 col-md-6">
      <FormKit
        v-if="companyModel"
        validation="required|number|length:8,8"
        name="ico"
        :label="$t('IČO')"
        :validation-messages="{
          required: $t('IČO je povinný údaj'),
          length: $t('IČO musí mať 8 číslic')
        }"
      />
      <FormKitCustomBirthdate v-else />
    </div>
    <div class="col-12 col-md-6">
      <FormKit
        v-if="companyModel"
        validation="required"
        name="company_name"
        :label="$t('Názov spoločnosti')"
        :validation-messages="{
          required: $t('Názov spoločnosti je povinný údaj'),
        }"
      />
      <FormKit
        v-else
        validation="required"
        name="first_name"
        :label="$t('Meno')"
        :validation-messages="{
          required: $t('Meno je povinný údaj'),
        }"
      />
    </div>
    <div class="col-12 col-md-6">
      <FormKit
        v-if="companyModel"
        validation="required"
        name="person_name"
        :label="$t('Zastupujúca osoba')"
        :validation-messages="{
          required: $t('Zastupujúca osoba je povinný údaj'),
        }"
      />
      <FormKit
        v-else
        validation="required"
        name="last_name"
        :label="$t('Priezvisko')"
        :validation-messages="{
          required: $t('Priezvisko je povinný údaj'),
        }"
      />
    </div>
  </div>
</template>
